<div class="container-fluid p-1 px-3 border rounded bg-light">
  <form>
    <div class="row mt-2 small-gutters">
      <div class="col-md-2">
        <ng-select
          class="w-100"
          bindValue="value"
          bindLabel="display"
          name="statuses"
          placeholder="Status"
          [multiple]="true"
          [items]="statusFilterOptions"
          (remove)="onStatusFilterChange()"
          (change)="onStatusFilterChange()"
          [(ngModel)]="filters.statuses"
          />
      </div>
      <div class="col-md-2">
        <ng-select
          class="w-100"
          bindValue="value"
          bindLabel="display"
          name="reasons"
          placeholder="Reasons"
          [multiple]="true"
          [items]="statusReasonFilterOptions"
          (remove)="onStatusReasonFilterChange()"
          (change)="onStatusReasonFilterChange()"
          [(ngModel)]="filters.reasons"
          [disabled]="statusReasonFilterOptions.length === 0"
          />
      </div>
      <div class="col-md-2">
        <app-client-select
          [(selectedIds)]="filters.clientIds"
          (changed)="onFilterChange()"
          [clients]="clientFilterOptions"
          minWidth='none'
          placeholder="Client"
          name="clientIds" />
      </div>
      <div class="col-md-2">
        <ng-select
          class="w-100"
          bindValue="id"
          bindLabel="username"
          name="assignedUserIds"
          placeholder="Assigned Client Lead"
          [multiple]="true"
          [items]="assignedUsersFilterOptions"
          (remove)="onFilterChange()"
          (change)="onFilterChange()"
          [(ngModel)]="filters.assignedUserIds"
          />
      </div>
      <div class="col-md-2">
        <ng-select
          class="w-100"
          bindValue="value"
          bindLabel="display"
          name="sources"
          placeholder="Source"
          [multiple]="true"
          [items]="claimSourceOptions"
          (remove)="onFilterChange()"
          (change)="onFilterChange()"
          [(ngModel)]="filters.sources"
          />
      </div>
    </div>
    <div class="row mt-2 mb-2">
      <div class="col-md-8">
        <div class="d-flex flex-row align-items-center">
          <div class="col-auto px-1">
            High Value:
            <mat-slide-toggle
              name="highValue"
              [color]="'primary'"
              [(ngModel)]="filters.highValue"
              [disableRipple]="true"
              (change)="onFilterChange()"
              />
          </div>
          <div class="col-auto px-1">
            Specialty:
            <mat-slide-toggle
              name="specialtyStore"
              [color]="'primary'"
              [(ngModel)]="filters.specialtyStore"
              [disableRipple]="true"
              (change)="onFilterChange()"
              />
          </div>
          <div class="col-auto px-1">
            Active:
            <mat-slide-toggle
              name="active"
              [color]="'primary'"
              [(ngModel)]="filters.activeClientsOnly"
              [disableRipple]="true"
              (change)="onFilterChange()"
              />
          </div>
          <div class="col-auto px-1">
            Remove Pilot Clients:
            <mat-slide-toggle
              name="excludeDirectUserAssignmentWorkflowClients"
              [color]="'primary'"
              [(ngModel)]="filters.excludeDirectUserAssignmentWorkflowClients"
              [disableRipple]="true"
              (change)="onFilterChange()"
              />
          </div>
          <div class="col-auto px-1">
            <div class="mt-1 d-flex align-items-center">
              <label class="me-3">Manual Fax Sent:</label>
              <div>
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="manualFaxSent"
                    id="manualFaxSentYes"
                    (change)="onFilterChange()"
                    [value]="true"
                    [(ngModel)]="filters.manualFaxSent"
                    />
                  <label class="form-check-label" for="manualFaxSentYes">Yes</label>
                </div>
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="manualFaxSent"
                    id="manualFaxSentNo"
                    (change)="onFilterChange()"
                    [value]="false"
                    [(ngModel)]="filters.manualFaxSent"
                    />
                  <label class="form-check-label" for="manualFaxSentNo">No</label>
                </div>
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="manualFaxSent"
                    id="manualFaxSentAll"
                    (change)="onFilterChange()"
                    [value]="null"
                    [(ngModel)]="filters.manualFaxSent"
                    />
                  <label class="form-check-label" for="manualFaxSentAll">All</label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-auto pe-2">
            <label>Days To Expiration:</label>
          </div>
          <div class="col">
            <input
              type="text"
              class="form-control form-control-sm"
              name="expiringWithinDays"
              appExcludeInputPattern
              excludedPattern="\D"
              maxlength="3"
              style="width: 5ch;"
              [(ngModel)]="filters.expiringWithinDays"
              (keyup)="onFilterChange()"/>
          </div>
        </div>
      </div>
      <div class="col-4">
        <div class="d-flex flex-row justify-content-end flex-wrap">
          <div class="col-auto d-flex align-items-center">
            Sort:
          </div>
          <div class="col-md-6 mx-1 sort-by">
            <ng-select
              class="w-100"
              name="cursorType"
              bindValue="value"
              bindLabel="display"
              [multiple]="false"
              [items]="cursorTypeOptions"
              [clearable]="false"
              [searchable]="false"
              (change)="onCursorTypeChange()"
              [(ngModel)]="cursorType"/>
          </div>
          <div class="btn-group col-auto">
            <button type="submit" [disabled]="disableSearch" class="btn btn-primary" (click)="onSearchClick()">Search</button>
            <button type="reset" class="btn btn-info" (click)="handleResetClick($event)">Reset</button>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
<span [hidden]="!captureCountLoaded">
  @if (captureCount === 0) {
    <div>
      <p class="mt-2 ms-1">No captures found. Try modifying the filters.</p>
    </div>
  } @else {
    {{ captureCount | number }} {{ captureCount === 1 ? 'capture' : 'captures' }}
  }
</span>

